import React, { Component } from 'react';
import './HandHistory.css';
import Media from 'react-responsive';
import { connect } from "react-redux";
import { saveActivity } from "../../common/commonService";
import moment from "moment";
import { getColor, getTextColor } from '../../common/ThemeService';
import i18next from 'i18next';
class HandHistoryHeader extends Component {

    saveActivityReplayHands = () => {
        saveActivity({
            hit_page: 'MyHands',
            hit_type: ('Replay Hand' + (this.props.selectedHandList.length > 1 ? "s" : "")),
            hit_attribute1: moment(this.props.from).startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
            hit_attribute2: (this.props.holeCards && this.props.holeCards.length > 0) ? this.props.holeCards.join(',') : "All",
            hit_attribute3: this.props.gameType,
            hit_attribute4: this.props.selectedHandList.length.toString(),
            hit_attribute5: moment(this.props.to).startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
        })
    }
    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        return (
            <div className="background-handHistory hand-history-header-padding header-handHistory">
                <div className="display-flex space-between">
                    <div className="vertical-align-card">
                        <span className="hand-history-header-name" style={{ textTransform: "capitalize" }}>
                            {localStorage.getItem("first_name") ? (localStorage.getItem("first_name") + "'s") : ""} {this.props.gameType === "cash" ? "Cash" : (this.props.gameType === "Spin" ? "Spins": this.props.gameType)} {i18next.t("lable.hands")} </span>
                    </div>
                    <div className="hand-history-padding-top-5 display-flex">
                        <Media query="(max-width: 900px)" maxWidth={900}>
                            {matches => matches ? null :
                                <sapn>
                                    {this.props.showReplayBtn ? (this.props.hands>0 && this.props.selectedHandList.length>0 && <div data-e2e="rePlayHands" className="ReplayHandsBtn" onClick={(e) => {
                                        e.preventDefault();
                                        this.saveActivityReplayHands()
                                        if (this.props.selectedHandList.length > 20) {
                                            document.getElementById("HandLimitPopupTriggerBtn").click()
                                        } else {
                                            this.props.showMultiReplayer();
                                        }
                                    }}> {i18next.t("lable.replayHand")}{this.props.selectedHandList.length > 1 ? "s" : ""}</div>) : <div className="padding-top-hand-history-20" style={{ alignSelf: "center" }}>
                                            <span className="hand-history-header-name-span padding-right-18">
                                                {this.props.gameType === "Spin"
                                                    // ? (this.props.ringType === "All" ? "All Seats" : (this.props.ringType === "Heads-up" ? "3 Max" : this.props.ringType))
                                                    ? "3 Max"
                                                    : (this.props.ringType === "All" ? i18next.t("lable.allSeats") : this.props.ringType)}, {this.props.level === "All Level" ? i18next.t("lable.allStakes") : this.props.level}
                                            </span>
                                        </div>}
                                </sapn>
                            }
                        </Media>
                        <Media query="(min-width: 901px)">
                            {matches => matches ? null :
                                <sapn>{this.props.showReplayBtn && <div className="ReplayHandsBtnFixedBottom" onClick={(e) => {
                                    e.preventDefault();
                                    this.saveActivityReplayHands()
                                    if (this.props.selectedHandList.length > 20) {
                                        document.getElementById("HandLimitPopupTriggerBtn").click()
                                    } else {
                                        this.props.showMultiReplayer();
                                    }
                                }}> {i18next.t("lable.replay")} {this.props.selectedHandList.length} {i18next.t("lable.hand")}{this.props.selectedHandList.length > 1 ? "s" : ""}</div>}
                                </sapn>
                            }
                        </Media>
                        <div className="close-button-padding-top">
                            <span className="hand-history-span" >
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.props.setShowFilterModal(true)
                                    }}
                                    className='missionbtn skillEditButton myHands_skillEditButton' 
                                    style={{
                                        backgroundColor: themeColor,
                                    }}>
                                    <i style={{ color: themeTextColor, fontSize: "20px" }} className="fa fa-filter"></i>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
                <Media query="(max-width: 900px)" maxWidth={900}>
                    {matches => matches ?
                        <div className="hand-history-padding-bottom-5">
                            <span className="hand-history-header-name-span">
                                {this.props.gameType === "Spin"
                                    // ? (this.props.ringType === "All" ? "All Seats" : (this.props.ringType === "Heads-up" ? "3 Max" : this.props.ringType))
                                    ? "3 Max"
                                    : (this.props.ringType === "All" ? i18next.t("lable.allSeats") : this.props.ringType)}, {this.props.level === "All Level" ? i18next.t("lable.allStakes") : this.props.level}
                            </span>
                        </div> : null}
                </Media>
                <div className="hand-histroy-stats-div">
                    <span className="hand-history-stats">
                    {i18next.t("lable.handsPlayed")}: {this.props.hands}
                    </span>
                    {/* <span className="hand-history-stats">
                        P&L: {this.props.totalProfit && this.props.totalProfit != "" ? parseFloat(this.props.totalProfit).toFixed(2) : 0}
                    </span> */}
                </div>
                <Media minWidth={769}>
                    <div className="border-bottom-hand-history border_full_length" style={{ marginTop: "15px" }}></div>
                </Media>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        holeCards: state.handHistory.filter.holeCards,
        from: state.handHistory.filter.from,
        to: state.handHistory.filter.to,
        gameType: state.handHistory.filter.gameType,
        ringType: state.handHistory.filter.ringType,
        level: state.handHistory.filter.level,
        selectedHandList: state.handHistory.selectedHandList,
        lang: state.header.lang
    }
}

export default connect(mapStateToProps, null)(HandHistoryHeader);



/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/HandHistoryHeader.js
 **/